import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { API } from "../Services/Api";
import {

  enderecos_api,
} from "../Utils/Urls";

interface IEntidadeContextData {
  entidade: IEntidade;
  token: boolean | string;
  usuario: IUsuario;
  getEntidadePorNomeDoBanco:(banco:string) => Promise<void>;
}

interface IEntidadeProviderProps {
  children: ReactNode;
}



const EntidadeContext = createContext({} as IEntidadeContextData);
export const token_storage = "@login-unico";
function EntidadeProvider({ children }: IEntidadeProviderProps) {
  const [entidade, setEntidade] = useState({} as IEntidade);
  const [usuario, setUsuario] = useState({} as IUsuario);
  const [token, setToken] = useState(false as boolean | string);
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const [loading, setLoading] = useState(false);

  async function getEntidadePorNomeDoBanco(banco:string) {
    try {
      setLoading(true);
    
      const entidade_carregada = await axios.get(
        `${enderecos_api}/cod/${banco}`
      );

      if (entidade_carregada.data.length > 0) {
        entidade_carregada.data[0].logo =
          enderecos_api + "/uploads/" + entidade_carregada.data[0].logo;

        setEntidade(entidade_carregada.data[0]);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
   
  }, [window.location.href]);




 



  return (
    <EntidadeContext.Provider
      value={{
        entidade,
        token,
        usuario,
        getEntidadePorNomeDoBanco
      }}
    >
      <>
        {children}

      
      </>
    </EntidadeContext.Provider>
  );
}

function useEntidade() {
  const context = useContext(EntidadeContext);

  return context;
}

export { EntidadeProvider, useEntidade };

interface IUsuario {
  usuario: {
    id: number;
    entidade_id: number;
    usuario: string;
    senha: string;
    email: string;
    inativo: null | string;
    nome: string;
    foto: null | string;
  };
  entidade: IEntidade;
  sistemas: [
    {
      id: number;
      titulo: string;
      url: string;
    }
  ];
}

interface IEntidade {
  id: number;
  titulo: string;
  banco: string;
  logo: string;
  apresentacao: string;
  portal: string;
  site: string;
  site2: string;
  pasta: string;
  pasta_unico:string;
}